const getEnv = (key: string, fallback = ""): string => {
  if (typeof window !== "undefined" && window._env_ && window._env_[key]) {
    return window._env_[key] as string;
  }
  if (typeof process !== "undefined" && process.env && process.env[key]) {
    return process.env[key] as string;
  }
  return fallback;
};

export const API_CONFIG = {
  // Fallback sob saluton.clinic de propósito: a sessão é cookie SameSite=Lax
  // e por `*.run.app` (Public Suffix List) o browser descarta o cookie.
  BASE_URL: getEnv(
    "REACT_APP_API_BASE_URL",
    "https://api.saluton.clinic",
  ),
  TIMEOUT: parseInt(getEnv("REACT_APP_API_TIMEOUT", "120000")),
  FIBONACCI_INTERVALS: [1000, 1000, 2000, 3000, 5000, 8000],
  // Teto do polling de recovery (STREAM e BATCH): depois de esgotar os
  // intervalos acima, continua tentando no último intervalo até esse total.
  MAX_POLL_DURATION_MS: 5 * 60 * 1000,
  DEBOUNCE_DELAY: 1000,
  PAGARME_PUBLIC_KEY: getEnv(
    "REACT_APP_PAGARME_PUBLIC_KEY",
    "pk_EaAw4G1DFbFzP1eg",
  ),
  PAGARME_API_URL: getEnv(
    "REACT_APP_PAGARME_API_URL",
    "https://api.pagar.me/core/v5",
  ),
  ENDPOINTS: {
    LOGIN: "/access/login",
    REFRESH_ACCESS_TOKEN: "/access/refresh-token",
    LOGOUT: "/access/logout",
    GET_ME: "/access/me",
    GET_USER: (userId: string) => `/user/${userId}`,
    CHAT_MESSAGE: "/ai-chat/message",
    CHAT_MESSAGE_STREAM: "/ai-chat/message/stream",
    CHAT_SESSIONS: "/ai-chat/sessions",
    CHAT_HISTORY: (sessionId: string) =>
      `/ai-chat/sessions/${sessionId}/history`,
    DELETE_SESSION: (sessionId: string) => `/ai-chat/sessions/${sessionId}`,
    UPDATE_DOCTOR_PROFILE: "/doctor/profile",
    UPDATE_DOCTOR_PHONE: "/doctor/phone",
    SUBSCRIPTION: "/doctor/subscription",
    SUBSCRIPTION_CHANGE_PLAN: "/doctor/subscription/change-plan",
    SUBSCRIPTION_CARD: "/doctor/subscription/card",
    SUBSCRIPTION_PRICING: "/doctor/subscription-pricing",
    LIFETIME_ACCESS: "/doctor/lifetime-access",
    LIFETIME_INSTALLMENTS: "/doctor/lifetime-access/installments",
    LIFETIME_LICENSES: "/doctor/lifetime-licenses",
    TERMS: "/access/terms?platform=weedy",
    ACCEPT_TERMS: "/access/terms/accept",
    UPDATE_PASSWORD: "/access/password",
    FORGOT_PASSWORD: "/access/forgot-password",
    VERIFY_RESET_CODE: "/access/verify-reset-code",
    RESET_PASSWORD: "/access/reset-password",
    DOCTOR_SIGNUP: "/access/doctor-signup",
    VERIFY_EMAIL_SIGNUP: "/access/verify-email-signup",
    WAITLIST: "/access/waitlist",
  },
};
